var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.426,
    height: 14.446,
    viewBox: "0 0 16.426 14.446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_take-_photo",
    "data-name": "Icon_take- photo",
    d: "M19.533,14.742H17.517l-.257-.8a1.7,1.7,0,0,0-1.729-1.317H10.59a1.7,1.7,0,0,0-1.727,1.311l-.259.81H6.656A2.039,2.039,0,0,0,4.88,16.8v8.5a1.776,1.776,0,0,0,1.775,1.775H19.532a1.776,1.776,0,0,0,1.775-1.775V16.8a2.038,2.038,0,0,0-1.774-2.055Zm.343,10.216a.622.622,0,0,1-.621.621H6.864a.622.622,0,0,1-.621-.621V16.8a.622.622,0,0,1,.621-.621h2.16a.578.578,0,0,0,.55-.4l.392-1.039c.083-.27.092-.3.626-.3h4.941c.534,0,.543.028.628.305l.385,1.032a.578.578,0,0,0,.55.4h2.16a.622.622,0,0,1,.621.621ZM13.1,16.435a4.057,4.057,0,1,0,4.057,4.057A4.061,4.061,0,0,0,13.1,16.435Zm0,6.96a2.9,2.9,0,1,1,2.9-2.9A2.907,2.907,0,0,1,13.1,23.395Z",
    transform: "translate(-4.88 -12.621)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoWidget);
export default __webpack_public_path__ + "static/media/PhotoWidget.38a6e6fb.svg";
export { ForwardRef as ReactComponent };